export const POLLS_GROUP_NAME = 'registration'

export const REGISTRATION_POLLS = {
  NUMBER_OF_CLIENTS: 'registration_number_of_clients',
  OTHER_APPS: 'registration_other_apps',
  BOOKSY_HELP: 'registration_booksy_help',
  BUSINESS_SETUP: 'registration_business_setup',
} as const

export const BUSINESS_SETUP_NO_STAFFERS_CHOICES = [
  'not_started_in_industry',
  'employed_at_another_salon',
  'work_solo',
  'own_space_work_alone',
] as const

export const POLL_TYPES = {
  SINGLE: 'single',
  MULTI_CHIP: 'multi_chip',
  MULTI_CHECKBOX: 'multi_checkbox',
} as const

export type PollType = (typeof POLL_TYPES)[keyof typeof POLL_TYPES]

const SUPPORTED_POLL_TYPES = new Set<string>(Object.values(POLL_TYPES))

export function isSupportedPollType (pollType: unknown): pollType is PollType {
  return typeof pollType === 'string' && SUPPORTED_POLL_TYPES.has(pollType)
}
